// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__60JkV","inputWrap":"CustomTip_inputWrap__3jjek"};